<template>
    <div v-if="ready">
        <form
            class="form-horizontal"
            enctype="multipart/form-data"
            @keydown="form.errors.clear($event.target.name)"
            autocomplete="off"
        >
            <backend-select
                :error="form.errors.get('type_id')"
                required
                :value="field('type_id')"
                v-model="selected_organisation_type"
                name="type"
                label="type"
                :route="route('types.index')"
                :disabled="this.id !== null"
            />

            <form-input
                :form="form"
                required
                name="name"
                v-if="weAreCreatingA('coach')
                    || weAreCreatingA('candidate')
                    || weAreCreatingA('id_employee')
                    || weAreCreatingA('supplier')
                    || weAreCreatingA('client')"
            />

            <!--<form-input-->
                <!--:form="form"-->
                <!--name="website"-->
                <!--v-if="weAreCreatingA('coach')-->
                    <!--|| weAreCreatingA('candidate')-->
                    <!--|| weAreCreatingA('id_employee')-->
                    <!--|| weAreCreatingA('supplier')-->
                    <!--|| weAreCreatingA('client')"-->
            <!--/>-->

            <!--<phone-number-->
                <!--:error="form.errors.get(['call_code', 'phone_number'])"-->
                <!--:phone-number="{ call_code: form.call_code, phone_number: form.phone_number }"-->
                <!--v-model="phone_number"-->
                <!--:form="form"-->
                <!--name="phone_number"-->
                <!--v-if="weAreCreatingA('coach')-->
                    <!--|| weAreCreatingA('candidate')-->
                    <!--|| weAreCreatingA('id_employee')-->
                    <!--|| weAreCreatingA('supplier')-->
                    <!--|| weAreCreatingA('client')"-->
            <!--/>-->

            <form-input
                :form="form"
                name="account_number"
                v-if="weAreCreatingA('coach')
                    || weAreCreatingA('candidate')
                    || weAreCreatingA('id_employee')
                    || weAreCreatingA('supplier')
                    || weAreCreatingA('client')"
            />

            <form-input
                :form="form"
                name="vat_number"
                v-if="weAreCreatingA('coach')
                    || weAreCreatingA('candidate')
                    || weAreCreatingA('id_employee')
                    || weAreCreatingA('supplier')
                    || weAreCreatingA('client')"
            />

            <form-input
                :form="form"
                name="coc_number"
                v-if="weAreCreatingA('coach')
                    || weAreCreatingA('candidate')
                    || weAreCreatingA('id_employee')
                    || weAreCreatingA('supplier')
                    || weAreCreatingA('client')"
            />

            <form-textarea
                name="note"
                rows="6"
                :form="form"
                v-if="weAreCreatingA('coach')
                    || weAreCreatingA('candidate')
                    || weAreCreatingA('id_employee')
                    || weAreCreatingA('supplier')
                    || weAreCreatingA('client')"
            />

            <active-select
                required
                name="active"
                :error="form.errors.get('active')"
                return="id"
                v-model="form.active"
                v-if="weAreCreatingA('coach')
                    || weAreCreatingA('candidate')
                    || weAreCreatingA('id_employee')
                    || weAreCreatingA('supplier')
                    || weAreCreatingA('client')"
            />

            <div v-if="weAreCreatingA('coach')
                || weAreCreatingA('candidate')
                || weAreCreatingA('supplier')
                || weAreCreatingA('client')"
            >
                <h4>{{ uLang('app.invoice_info') }}</h4>

                <form-input
                    :form="form"
                    name="email"
                />

                <form-input
                    :form="form"
                    name="salutation"
                />

                <backend-select
                    :error="form.errors.get('country')"
                    country
                    return="iso_3166_2"
                    valueKey="iso_3166_2"
                    :value="field('country')"
                    v-model="form.country"
                    name="country"
                    label="country"
                    :route="route('admin.countries.index')"
                    @input="validateAddress"
                />

                <form-input
                    :form="form"
                    name="zipcode"
                    @blur="validateAddress"
                />

                <form-input
                        :form="form"
                        name="house_number"
                        @blur="validateAddress"
                />

                <form-input
                    :form="form"
                    name="city"
                />

                <form-input
                    :form="form"
                    name="street"
                    @blur="validateAddress"
                />

                <backend-select
                    :error="form.errors.get('linked_organisation_ids')"
                    :value="field('linked_organisation_ids')"
                    return="id"
                    track-by="id"
                    multiple
                    v-model="form.linked_organisation_ids"
                    name="linked_organisation_ids"
                    label="linked_clients"
                    :route="route('organisations.index', {type: ['client']})"
                    :result-map="excludeSelf"
                    v-if="weAreCreatingA('client')"
                />
            </div>
        </form>

        <div
            v-if="!this.isUpdate()
                && (weAreCreatingA('coach')
                || weAreCreatingA('candidate')
                || weAreCreatingA('id_employee')
                || weAreCreatingA('supplier')
                || weAreCreatingA('client'))"
        >
            <h4>{{ uLang('app.addresses') }}</h4>

            <module-address
                @addressesUpdated="addressesUpdated"
                :title="uLang('app.add_address')"
                ref="addressModule"
            />
        </div>

        <div
            v-if="!this.isUpdate()
                && (weAreCreatingA('coach')
                || weAreCreatingA('candidate')
                || weAreCreatingA('id_employee')
                || weAreCreatingA('supplier')
                || weAreCreatingA('client'))"
        >
            <h4>{{ uLang('app.relations') }}</h4>

            <module-relation
                @relationsUpdated="relationsUpdated"
            />
        </div>

        <div
            v-if="!this.isUpdate()
                && (weAreCreatingA('coach')
                || weAreCreatingA('candidate')
                || weAreCreatingA('id_employee')
                || weAreCreatingA('supplier')
                || weAreCreatingA('client'))"
        >
            <h4>{{ uLang('app.files') }}</h4>

            <module-file
                    @filesUpdated="filesUpdated"
            />
        </div>

        <div class="form-group row">
            <label class="form-control-label col-md-3 col-xl-2 col-sm-12 col-form-label" for="sends_anonymous_invoices">{{ uLang('app.anonymize_invoice') }}</label>
            <div class="col-md-9 col-xl-10 col-sm-12">
                <label class="custom-control custom-checkbox mt-2">
                    <input type="checkbox" class="custom-control-input" id="sends_anonymous_invoices" value="1" v-model="form.sends_anonymous_invoices">
                    <span class="custom-control-indicator"></span>
                </label>
            </div>
        </div>

        <div class="form-group">
            <input
                :disabled="form.busy"
                type="button"
                @click.prevent="store"
                class="btn btn-brand mt-2"
                :value="uLang('app.save')"
            />
        </div>
    </div>
</template>

<script>
    import Form from '~/Form/Form'
    import { event }  from '~/events'
    import FormMixin from '~/mixins/form'
    import SuccessfullyStoredAlert from "~/Swals/SuccessfullyStoredAlert";
    import SuccessfullyUpdatedAlert from "~/Swals/SuccessfullyUpdatedAlert";
    import RelationModule from '~/components/forms/admin/relation/module'
    import { FileModule } from '~/components/modules'

    export default {
        name: 'form-admin-organisation',
        mixins: [FormMixin],
        components: {
            'module-relation': RelationModule,
            'module-file': FileModule,
        },
        props: {
            id: {
                required: false,
                default: null,
            },
            relationId: {
                required: false,
                default: null,
            },
            type : String
        },

        data() {
            return {
                entity: 'organisation',
                form: new Form({
                    email: '',
                    name: '',
                    type_id: null,
                    website: '',
                    note: '',
                    call_code: '+31',
                    phone_number: '',
                    account_number: '',
                    coc_number: '',
                    vat_number: '',
                    active: null,
                    addresses: [],
                    relations: [],
                    documents: [],
                    country: 'NL',
                    zipcode: '',
                    city: '',
                    street: '',
                    house_number: '',
                    salutation: '',
                    sends_anonymous_invoices: false,
                    linked_organisation_ids: [],
                }),
                invalidAddress: true,
                retrievingAddress: false,
                lastRequestedWith: {
                    zipcode: null,
                    house_number: null,
                },
                phone_number: null,
                selected_organisation_type: null,
                swal: false,
            }
        },
        watch: {
            selected_organisation_type(newVal, oldVal) {
                this.form.type_id = null
                if(newVal) {
                    this.form.type_id = newVal.id
                }
            },
            phone_number: function() {
                this.form.call_code = this.phone_number.call_code;
                this.form.phone_number = this.phone_number.number;
            },
        },
        mounted() {
            this.$on('afterStore', this.afterStore);
            this.$on('afterUpdate', this.afterUpdate);
            this.$on('afterRetrieve', (data) => {
                this.selected_organisation_type = data.type_id;
                if (data.call_code === null) {
                    this.form.call_code = '+31';
                }
            });
        },

        created() {
            this.selected_organisation_type = this.$route.params.type;

            this.retrieveRelation();
        },

        methods: {
            excludeSelf(organisations) {
                return organisations.filter(organisation => organisation.id !== Number(this.id));
            },
            weAreCreatingA(type) {
                return this.selected_organisation_type && this.selected_organisation_type.system_name == type;
            },
            show() {
                this.$router.push({ name: 'admin.organisations.view', params: { id: this.id }})
            },
            afterStore(data) {
                new SuccessfullyStoredAlert({entity: this.lang('app.organisation')}).show()
                    .then((buttonPressed) => {
                        if (buttonPressed === 'create_another') {
                            this.$refs.addressModule.clear();
                            this.selected_organisation_type = null;
                        } else if (buttonPressed === 'show') {
                            this.$router.push({name: 'admin.organisations.view', params: { id: data.id }});
                        }
                    });
            },
            afterUpdate(data) {
                new SuccessfullyUpdatedAlert({entity: this.lang('app.organisation')}).show()
                    .then(() => {
                        this.$router.push({name: 'admin.organisations.view', params: { id: this.id }});
                    });
            },
            addressesUpdated(addresses) {
                let newAddresses = addresses.map((address) => {
                    return address.id;
                });

                let addressesToDelete = _.difference(this.form.addresses, newAddresses);

                let len = addressesToDelete.length;
                for(let i = 0; i < len; i++) {
                    axios.delete(route('addresses.destroy', {'address': addressesToDelete[i]}));
                }

                this.form.addresses = newAddresses;
            },
            relationsUpdated(relations) {
                this.form.relations = relations.map((relation) => {
                    return relation.id
                });
            },
            filesUpdated(documents) {
                this.form.documents = documents.map((document) => {
                    return document.id
                });
            },

            validateAddress() {
                this.form.errors.clear('country');

                // Make zipcode uppercase and remove spaces.
                this.form.zipcode = this.form.zipcode.replace(/\s+/g, '').toUpperCase();

                if (this.form.street && this.form.street.toLowerCase() == 'postbus') {
                    this.form.errors.clear();
                    return;
                }

                if(this.form.country === 'NL' && (this.form.zipcode && this.form.zipcode.length >= 6 && this.form.zipcode.length <= 7) && (this.form.house_number && this.form.house_number.length > 0)) {

                    if (this.lastRequestedWith.zipcode === this.form.zipcode && this.lastRequestedWith.house_number === this.form.house_number) {
                        return;
                    }

                    this.lastRequestedWith.zipcode = this.form.zipcode;
                    this.lastRequestedWith.house_number = this.form.house_number;

                    this.retrievingAddress = true;

                    window.axios.get(route('admin.addresses.data', {
                        zipcode: this.form.zipcode,
                        house_number: this.form.house_number
                    }))
                        .then((response) => {
                            this.invalidAddress = false;

                            this.form.street = response.data.street;
                            this.form.city = response.data.city;

                            this.retrievingAddress = false;
                        })
                        .catch((error) => {
                            this.invalidAddress = true;

                            if (error.response.status === 422) {
                                this.form.errors.record(error.response.data.errors);
                            }

                            this.form.street = '';
                            this.form.city = '';

                            this.retrievingAddress = false;
                        });
                }
            },
           async retrieveRelation() {
                // No prefilling if the relation is not available
                if (this.relationId === null) {
                    return;
                }

                const { data } = await window.axios.get(route('relations.show', { relation: this.relationId }));
                this.form.name = data.full_name;
                this.form.email = data.email;
                this.form.active = 1;
                this.form.salutation = data.fully_qualified_name;
                this.form.addresses = data.addresses;
                this.form.house_number = data.addresses[0].house_number;
                this.form.city = data.addresses[0].city;
                this.form.street = data.addresses[0].street;
                this.form.zipcode = data.addresses[0].zipcode;
           },
        }
    }
</script>

<style lang="css" scoped>
    .remove-address {
        margin-right: 20px;
    }
</style>
